var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Drawer',{attrs:{"title":_vm.title,"placement":"right","width":_vm.maxScreenWidth,"before-close":_vm.closeDrawerTicket,"value":_vm.value},on:{"input":v => _vm.$emit('input', v)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }